import { CookieContext } from '../../providers';
import { UserCookieAcceptance } from '@investigator/features/user/queries';
import { useContext } from 'react';

export const useGetHasUserAcceptedAnalytics = () => {
  const { getUserCookieAcceptance } = useContext(CookieContext);

  const analyticsCookie: UserCookieAcceptance = getUserCookieAcceptance?.filter(
    (cookie) => cookie.cookie_type === 'ANALYTICS',
  )?.[0];

  return () =>
    Boolean(
      analyticsCookie?.cookies_accepted_expiration &&
        analyticsCookie?.cookies_accepted,
    );
};
